<template>
  <div class="view pa24">
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <Search ref="search" :wareStatus="wareStatus"  @search="searchList"></Search>
        </el-col>
      </el-row>
    </div>
    <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column
          prop="lotNumber"
          align="center"
          label="批次号"
      />
      <el-table-column
          prop="num"
          align="center"
          label="数量"
      >
      </el-table-column>
      <el-table-column
          prop="weight"
          align="center"
          label="重量(t)"
      >
      </el-table-column>
      <el-table-column
          prop="toWarehouse"
          align="center"
          label="目标库位"
      >
      </el-table-column>
      <el-table-column
          prop="toWarehouse"
          align="center"
          label="目标容器"
      >
        <template slot-scope="scope">
          {{scope.row.toCodeName}} {{scope.row.toCodeHandle}}
        </template>
      </el-table-column>
      <el-table-column
          prop="remarks"
          align="center"
          label="备注"
      />
      <el-table-column
          prop="createBy"
          align="center"
          label="操作人"
      />
      <el-table-column
          prop="createTime"
          align="center"
          label="出库时间"
      />
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="codeDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 15, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          class=""
          :total="total"
          :pager-count="5"
      />
    </div>
  </div>
</template>
<script>
import {selectLogBatchList} from  '@/api/storeLogBatch.js'
import Search from "./component/search.vue";
export default {
  components: {
    Search
  },
  props:{

  },
  data() {
    return {
      name:null,
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      wareStatus:5,
      queryParam:''
    };
  },
  created() {
    this.getList()
  },
  methods: {
    getCustomer(){
      this.getList()
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    handleAddCode(id) {
      this.$router.push({path:'/store/addCode'})
    },
    getList() {
      let params={
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        wareStatus:this.wareStatus,
        ...this.queryParam
      }
      selectLogBatchList(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    codeDetail(row){
      this.$router.push({path:'/store/logCodeDetail',query:{id:row.id,source:5,isWarehouse:row.isWarehouse}})
    },
    searchList(val){
      this.queryParam = val
      this.getList()
    }
  },

}
</script>
<style scoped>
.pageBox {
  display: flex;
  justify-content: flex-end;
}
</style>
